import React, { useEffect, useState } from 'react'
import styles from "./download.module.css"
import { MdDownload, MdPlayArrow } from 'react-icons/md'
import CircularProgress from '../../../CircularProgress'

const Download = ({ width, height, downloading = false, isAudio = false, downloadMedia = () => { } }) => {
    const [progressDownload, setProgressDownload] = useState(0)
    const style = isAudio ? { height: "30px" } : { minWidth: width > 0 && width < 350 ? `${width}px` : "350px", minHeight: height > 0 && height < 350 ? `${height}px` : "300px" }

    useEffect(() => {
        if (downloading) {
            const interval = setInterval(() => {
                setProgressDownload(previousValue => previousValue + Math.floor(Math.random() * 5) + 1)
            }, 1000)

            return () => clearInterval(interval)
        }
    }, [downloading])

    return (
        <div className={`${styles.container} ${isAudio ? styles.isAudio : ''}`} style={style}>
            {isAudio &&
                <div className={styles.audio}>
                    <MdPlayArrow />
                    <div className={styles.progressBar}></div>
                </div>
            }
            <div>
                {downloading ?
                    <CircularProgress value={progressDownload} size={isAudio ? 40 : 50} />
                    :
                    <div className={styles.download} onClick={downloadMedia}>
                        <MdDownload />
                    </div>
                }
            </div>
        </div>
    )
}

export default Download
